export enum timelineCategory {
  launches = "Launches",
  press = "Press",
  milestones = "Milestones",
  irlEvents = "irl Events",
  movies = "Movies",
}
